"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRetryErrorSwrOptions = exports.getRetryErrorSwrInfiniteOptions = exports.basicSwrOptions = void 0;
var _axios = require("@ori/axios");
/* istanbul ignore file @preserve --config */ var basicSwrOptions = exports.basicSwrOptions = {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
};
var ERROR_RETRY_COUNT = 3;
var ERROR_RETRY_INTERVAL = 2000;
var getRetryErrorSwrOptions = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.retryCount, retryCountParam = tmp === void 0 ? ERROR_RETRY_COUNT : tmp, _ref_retryInterval = _ref.retryInterval, retryInterval = _ref_retryInterval === void 0 ? ERROR_RETRY_INTERVAL : _ref_retryInterval;
    return _object_spread_props(_object_spread({}, basicSwrOptions), {
        shouldRetryOnError: true,
        errorRetryCount: retryCountParam,
        errorRetryInterval: retryInterval,
        // eslint-disable-next-line max-params -- library requires too many parameters
        onErrorRetry: function(error, _, config, revalidate, param) {
            var retryCount = param.retryCount;
            var _error_response;
            var _error_response_status;
            var statusCode = (_error_response_status = (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) !== null && _error_response_status !== void 0 ? _error_response_status : _axios.HttpStatusCode.GatewayTimeout;
            if (statusCode >= _axios.HttpStatusCode.BadRequest && statusCode < _axios.HttpStatusCode.InternalServerError) {
                return;
            }
            var _config_errorRetryCount;
            if (retryCount >= ((_config_errorRetryCount = config.errorRetryCount) !== null && _config_errorRetryCount !== void 0 ? _config_errorRetryCount : 0)) {
                return;
            }
            setTimeout(function() {
                return void revalidate({
                    retryCount: retryCount
                });
            }, config.errorRetryInterval);
        }
    });
};
exports.getRetryErrorSwrOptions = getRetryErrorSwrOptions;
var getRetryErrorSwrInfiniteOptions = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.retryCount, retryCountParam = tmp === void 0 ? ERROR_RETRY_COUNT : tmp, _ref_retryInterval = _ref.retryInterval, retryInterval = _ref_retryInterval === void 0 ? ERROR_RETRY_INTERVAL : _ref_retryInterval;
    return _object_spread_props(_object_spread({}, basicSwrOptions), {
        shouldRetryOnError: true,
        errorRetryCount: retryCountParam,
        errorRetryInterval: retryInterval,
        // eslint-disable-next-line max-params -- library requires too many parameters
        onErrorRetry: function(error, _, config, revalidate, param) {
            var retryCount = param.retryCount;
            var _error_response;
            var _error_response_status;
            var statusCode = (_error_response_status = (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) !== null && _error_response_status !== void 0 ? _error_response_status : _axios.HttpStatusCode.GatewayTimeout;
            if (statusCode >= _axios.HttpStatusCode.BadRequest && statusCode < _axios.HttpStatusCode.InternalServerError) {
                return;
            }
            var _config_errorRetryCount;
            if (retryCount >= ((_config_errorRetryCount = config.errorRetryCount) !== null && _config_errorRetryCount !== void 0 ? _config_errorRetryCount : 0)) {
                return;
            }
            setTimeout(function() {
                return void revalidate({
                    retryCount: retryCount
                });
            }, config.errorRetryInterval);
        }
    });
};
exports.getRetryErrorSwrInfiniteOptions = getRetryErrorSwrInfiniteOptions; //# sourceMappingURL=swrConfig.js.map
